import React, { useState, useEffect } from 'react';
import AccordionPanel from './accordion-panel';

interface AccordianProps {
  controlledAccordian?: boolean;
  panels: any;
  panelIndexToOpen?: number;
  onPanelExpand?: any;
}

const Accordian: React.FC<AccordianProps> = ({ 
  panels, 
  controlledAccordian=false,
  onPanelExpand,
  panelIndexToOpen=0 }) => {
  const [currentAccordianIndex, setCurrentAccordianIndex] = useState<number>(controlledAccordian ? 0 : null);
  
  useEffect(() => {
    if (panels && panels.length > 0) { 
      setCurrentAccordianIndex(panelIndexToOpen);
    }
  }, [panels]);  

  return (
    <>
      {
        panels.map((panel, index) => <AccordionPanel key={panel.name}
          expanded={controlledAccordian ? index === currentAccordianIndex : true} 
          onChange={
            controlledAccordian ? 
            (panelIndex, isExpanded) => {
              panel.expanded = isExpanded;
              if (isExpanded && onPanelExpand){
                onPanelExpand(panelIndex);
              }
              setCurrentAccordianIndex(isExpanded ? panelIndex : null);
            } : null
          } 
          index={index} panelName={panel.name} panelFields={panel.fields} panelDescription={panel.description}
          status={panel.status} />)

      }
    </>
  );
};

export default Accordian;